export default {
    setWorkVideo (state, { videoObject }) {
        state.workVideo = videoObject
    },
    setLifeVideo (state, { videoObject }) {
        state.lifeVideo = videoObject
    },
    setMoneyVideo (state, { videoObject }) {
        state.moneyVideo = videoObject
    },
    setMindbodyVideo (state, { videoObject }) {
        state.mindbodyVideo = videoObject
    },
    setCommunityVideo (state, { videoObject }) {
        state.communityVideo = videoObject
    },
    setWorkLearnMoreVideo (state, { videoObject }) {
        state.workLearnMore = videoObject
    },
    setLifeLearnMoreVideo (state, { videoObject }) {
        state.lifeLearnMore = videoObject
    },
    setMindbodyLearnMoreVideo (state, { videoObject }) {
        state.mindbodyLearnMore = videoObject
    },
    setMoneyLearnMoreVideo (state, { videoObject }) {
        state.moneyLearnMore = videoObject
    },
    setCommunityLearnMoreVideo (state, { videoObject }) {
        state.communityLearnMore = videoObject
    },
    setMainVideo (state, { videoObject }) {
        state.mainVideo = videoObject
    },
    setAboutUsVideo (state, { videoObject }) {
        state.aboutusVideo = videoObject
    },
    setLiveEventVideo (state, { videoObject }) {
        state.liveEventVideo = videoObject
    },
    setTriggerLogin (state, loginStatus) {
        state.triggerLogin = loginStatus
    },
    setAllUnauthVideos (state, {videos}) {
        state.allUnauthVideos = videos
    },
    setAllTestimonials (state, {testimonials}) {
        state.allTestimonials = testimonials
    },
    setCorpReference (state, {corp}) {
        state.corpReference = corp
    },
    setMarketingPlan (state, {planId}) {
        if (planId) {
            state.marketingPlanId = planId
            sessionStorage.setItem('marketingPlan', planId)
        } else {
            state.marketingPlanId = null
        }
    },
    setCorporateGiftingCode (state, {giftCode}) {
        if (giftCode) {
            state.corporateGiftingCode = giftCode
            localStorage.setItem('corporateGiftingCode', giftCode)
        } else {
            state.corporateGiftingCode = null
            if (localStorage.getItem('corporateGiftingCode')) {
                localStorage.removeItem('corporateGiftingCode')
            }
        }
    },
    setCorporateClientId (state, {corporateClientId}) {
        if (corporateClientId) {
            state.corporateClientId = corporateClientId
            localStorage.setItem('corporateClientId', corporateClientId)
        } else {
            state.corporateClientId = null
            if (localStorage.getItem('corporateClientId')) {
                localStorage.removeItem('corporateClientId')
            }
        }
    },
    setCompanyLogos (state, {logos}) {
        state.companyLogos = logos
    }
}



// WEBPACK FOOTER //
// ./src/store/unauthpage/mutations.js